export default class CampaignBuyMoreProductModel {
    constructor() {
        this.campaignId = 0;
        this.productId = 0;
    }
}
